import { Empty } from 'antd'
import { PropsWithChildren } from 'react'

import { Note } from '@types'

import { NoteElement } from '../../../NoteElement'
import InfoSection from '../components/InfoSection'

interface NotesSectionProps {
  notes: Note[]
}

const NotesSection: React.FC<PropsWithChildren<NotesSectionProps>> = ({ notes, children }) => (
  <InfoSection header="Notas">
    {notes?.length ? (
      <>
        {notes.map((observation: Note) => (
          <NoteElement data={observation} />
        ))}
      </>
    ) : (
      <Empty />
    )}
    {children}
  </InfoSection>
)

export default NotesSection
